import React from 'react';
import { Sidebar, useSidebar } from '@/components/ui/sidebar';
import { UserRole } from '@/types';
import { useDeviceType } from '@/hooks/useDeviceType';
import SidebarHeader from './sidebar/SidebarHeader';
import SidebarNavigation from './sidebar/SidebarNavigation';
import SidebarRoleIndicator from './sidebar/SidebarRoleIndicator';

interface AppSidebarProps {
  userRole: UserRole;
}

const AppSidebar: React.FC<AppSidebarProps> = ({ userRole }) => {
  const { isTablet } = useDeviceType();
  
  return (
    <Sidebar
      className="border-r bg-card"
      collapsible="icon"
      // Default to collapsed on tablets for more content space
      variant={isTablet ? "sidebar" : "sidebar"}
    >
      <div className="h-full flex flex-col">
        <SidebarHeader />
        <SidebarRoleIndicatorWrapper userRole={userRole} />
        <SidebarNavigation userRole={userRole} />
      </div>
    </Sidebar>
  );
};

// Wrapper to access sidebar state
const SidebarRoleIndicatorWrapper: React.FC<{ userRole: UserRole }> = ({ userRole }) => {
  const { state, isMobile } = useSidebar();
  const { isTablet } = useDeviceType();
  
  // On mobile, always show full content (not collapsed)
  // On tablet, respect the collapsed state
  const collapsed = state === 'collapsed' && !isMobile;
  
  return <SidebarRoleIndicator role={userRole} collapsed={collapsed} />;
};

export default AppSidebar;
